/**
 * @author: junjunzuo(junjunzuo@tencent.com)
 * @description: detail
 * @Date: 2020-06-15 16:43:40
 */

import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    head: '',
    itemData: {},
  }),
  mutations: {
    [types.UPDATE_UPLOADER_HEAD](state, head) {
      state.head = head;
    },
    [types.UPDATE_UPLOADER_ITEM](state, item) {
      state.itemData = item;
    },
  },
  actions: {
    /**
     * up主详情页
     * @param commit
     * @param context
     * @param route
     * @returns {Promise<*>}
     */
    async prefetchData({ commit }, { context, route }) {
      const $params = context ? context.$params : {};
      const params = Object.assign({}, route.query, { routeName: route.name }, $params);
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/uploader`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));
      result = result && result.data;
      const { status, head = '', itemData } = result || {};
      if (status === 301) return result;
      if (status === 0 && itemData) {
        commit(types.UPDATE_UPLOADER_HEAD, head);
        commit(types.UPDATE_UPLOADER_ITEM, itemData);
        return result;
      }
      commit(types.UPDATE_UPLOADER_HEAD, '');
      commit(types.UPDATE_UPLOADER_ITEM, {});

      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },
  },
};
